module.exports = __webpack_public_path__ + "media/ppc/hero-caucasian-female-5d925869.jpg";